<h2 class="sub-header-bar">Postcodes</h2>

<form (ngSubmit)="search()" style="width: 100%">
  <div class="filterPanel form-group flex flex-wrap grid-gap-15">
    <div class="flex-shrink-1">
      <span class="md-inputfield filterItem">
        <input
          name="firstName"
          type="text"
          pInputText
          [(ngModel)]="filterVal.filters.postcode.value"
        />
        <label>Postcode</label>
      </span>
    </div>

    <div class="flex-shrink-1">
      <button pButton class="btn-to-right" type="submit" label="Search"></button>
      <button
        pButton
        class="btn-to-right ui-button-tertiary"
        type="button"
        label="Clear"
        (click)="clearFilter()"
      ></button>
      <button
        pButton
        class="btn-to-right ui-button-tertiary"
        type="button"
        (click)="download()"
        label="Download"
      ></button>
    </div>
  </div>
</form>

<p-table
  sortField=""
  [value]="page.items"
  [lazy]="true"
  [rows]="100"
  [responsive]="true"
  [paginator]="true"
  rowHover="true"
  resizableColumns="true"
  [rowsPerPageOptions]="[10, 50, 100]"
  [pageLinks]="3"
  [totalRecords]="page.total"
  (onLazyLoad)="onGridLazyLoad($event)"
  [(selection)]="selectedWeight"
  [hidden]="!isLoaded"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Postcode</th>
      <th>Customer Weighting Code</th>
      <th>Supplier Weighting Code</th>
      <th>Customer Weighting Fixed Pickup</th>
      <th>Customer Weighting Fixed Dropoff</th>
      <th>Supplier Weighting Fixed Pickup</th>
      <th>Supplier Weighting Fixed Dropoff</th>
      <th>Comments</th>
      <th>Updated By</th>
      <th>Updated</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr (click)="onRowClick(item)" [pSelectableRow]="item">
      <td>{{ item.postcode }}</td>

      <td style="text-align: center">
        <input
          pInputText
          style="display: inline-block; width: 50px"
          [(ngModel)]="item.customerWeight"
          (change)="cellEdit(item)"
          [minVal]="0"
          [maxVal]="10"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="!isPricingAdmin"
        />
      </td>

      <td style="white-space: nowrap; text-align: center">
        <input
          pInputText
          class="input-cell"
          [(ngModel)]="item.supplierWeight"
          (change)="cellEdit(item)"
          [minVal]="0"
          [maxVal]="10"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="!isPricingAdmin"
        />
      </td>

      <td style="white-space: nowrap; text-align: center">
        £
        <input
          pInputText
          [(ngModel)]="item.customerWeightFixedPickup"
          class="input-cell"
          (change)="cellEdit(item)"
          [minVal]="0"
          [maxVal]="999"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="!isPricingAdmin"
        />
      </td>

      <td style="white-space: nowrap; text-align: center">
        £
        <input
          pInputText
          class="input-cell"
          [(ngModel)]="item.customerWeightFixedDropoff"
          (change)="cellEdit(item)"
          [minVal]="0"
          [maxVal]="999"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="!isPricingAdmin"
        />
      </td>

      <td style="white-space: nowrap; text-align: center">
        £
        <input
          pInputText
          class="input-cell"
          [(ngModel)]="item.supplierWeightFixedPickup"
          (change)="cellEdit(item)"
          [minVal]="0"
          [maxVal]="999"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="!isPricingAdmin"
        />
      </td>
      <td style="white-space: nowrap; text-align: center">
        £
        <input
          pInputText
          class="input-cell"
          [(ngModel)]="item.supplierWeightFixedDropoff"
          (change)="cellEdit(item)"
          [minVal]="0"
          [maxVal]="999"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="!isPricingAdmin"
        />
      </td>
      <td>
        <input
          pInputText
          [(ngModel)]="item.comments"
          (change)="cellEdit(item)"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="!isPricingAdmin"
        />
      </td>
      <td>{{ item.updatedByUserName }}</td>
      <td>
        <div title="{{ item.updatedOn | date : 'dd/MM/yyyy HH:mm' }}">
          {{ item.updatedOn | date : 'dd/MM/yyyy HH:mm' }}
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<!--- DATATABLES DEPRECATED ---
    <p-dataTabl sortField="" [value]="page.items" [lazy]="true" [rows]="100" [responsive]="true" [paginator]="true"
                 rowHover="true" resizableColumns="true" [rowsPerPageOptions]="[10,50,100]" [pageLinks]="3"
                 [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowClick)="onRowClick($event)"
                 [editable]="tru" [(selection)]="selectedWeight"
                 [hidden]="!isLoaded">
        <p-column field="postcode" header="Postcode" [sortable]="true" [editable]="false" [style]="{'width': '15%'}"></p-column>
        <p-column field="customerWeight" header="Customer Weighting" [sortable]="true" [editable]="tru" [style]="{'width': '10%'}">
            <ng-template let-col let-item="rowData" pTemplate="editor">
                <input pInputText [(ngModel)]="item.customerWeight"
                       (change)="cellEdit(item)" [minVal]="0" [maxVal]="10" intDigits
                       [ngModelOptions]="{standalone: true}" appendTo="body" />
            </ng-template>
        </p-column>
        <p-column field="supplierWeight" header="Supplier Weighting" [sortable]="true" [editable]="tru" [style]="{'width': '10%'}">
            <ng-template let-col let-item="rowData" pTemplate="editor">
                <input pInputText [(ngModel)]="item.supplierWeight"
                       (change)="cellEdit(item)" [minVal]="0" [maxVal]="10" intDigits
                       [ngModelOptions]="{standalone: true}" appendTo="body" />
            </ng-template>
        </p-column>
        <p-column pTooltip="Customer Weighting Fixed Pickup" field="customerWeightFixedPickup" header="Customer Fixed Pickup" [sortable]="true" [editable]="tru" [style]="{'width': '10%'}">
            <ng-template let-col let-item="rowData" pTemplate="body">
                {{ item.customerWeightFixedPickup | currency:'GBP':'symbol':'1.2-2' }}
            </ng-template>
            <ng-template let-col let-item="rowData" pTemplate="editor">
                <input pInputText [(ngModel)]="item.customerWeightFixedPickup"
                       (change)="cellEdit(item)" [minVal]="0" [maxVal]="999" decimalDigits
                       [ngModelOptions]="{standalone: true}" appendTo="body" />
                {{ item.customerWeightFixedPickup | currency:'GBP':'symbol':'1.2-2' }}
            </ng-template>
        </p-column>
        <p-column pTooltip="Customer Weighting Fixed Dropoff" field="customerWeightFixedDropoff" header="Customer Fixed Dropoff" [sortable]="true" [editable]="tru" [style]="{'width': '10%'}">
            <ng-template let-col let-item="rowData" pTemplate="body">
                {{ item.customerWeightFixedDropoff | currency:'GBP':'symbol':'1.2-2' }}
            </ng-template>
            <ng-template let-col let-item="rowData" pTemplate="editor">
                <input pInputText [(ngModel)]="item.customerWeightFixedDropoff"
                       (change)="cellEdit(item)" [minVal]="0" [maxVal]="999" decimalDigits
                       [ngModelOptions]="{standalone: true}" appendTo="body" />
                {{ item.customerWeightFixedDropoff | currency:'GBP':'symbol':'1.2-2' }}
            </ng-template>
        </p-column>
        <p-column pTooltip="Supplier Weighting Fixed Pickup" field="supplierWeightFixedPickup" header="Supplier Fixed Pickup" [sortable]="true" [editable]="tru" [style]="{'width': '10%'}">
            <ng-template let-col let-item="rowData" pTemplate="body">
                {{ item.supplierWeightFixedPickup | currency:'GBP':'symbol':'1.2-2' }}
            </ng-template>
            <ng-template let-col let-item="rowData" pTemplate="editor">
                <input pInputText [(ngModel)]="item.supplierWeightFixedPickup"
                       (change)="cellEdit(item)" [minVal]="0" [maxVal]="999" decimalDigits
                       [ngModelOptions]="{standalone: true}" appendTo="body" />
                {{ item.supplierWeightFixedPickup | currency:'GBP':'symbol':'1.2-2' }}
            </ng-template>
        </p-column>
        <p-column pTooltip="Supplier Weighting Fixed Dropoff" field="supplierWeightFixedDropoff" header="Supplier Fixed Dropoff" [sortable]="true" [editable]="tru" [style]="{'width': '10%'}">
            <ng-template let-col let-item="rowData" pTemplate="body">
                {{ item.supplierWeightFixedDropoff | currency:'GBP':'symbol':'1.2-2' }}
            </ng-template>
            <ng-template let-col let-item="rowData" pTemplate="editor">
                <input pInputText [(ngModel)]="item.supplierWeightFixedDropoff"
                       (change)="cellEdit(item)" [minVal]="0" [maxVal]="999" decimalDigits
                       [ngModelOptions]="{standalone: true}" appendTo="body" />
                {{ item.supplierWeightFixedDropoff | currency:'GBP':'symbol':'1.2-2' }}
            </ng-template>
        </p-column>
        <p-column field="comments" header="Comments" [sortable]="true" [editable]="tru"></p-column>
        <p-column field="updatedByUserName" header="Updated By" [sortable]="true" [editable]="false" [style]="{'width': '15%'}"></p-column>
        <p-column field="updatedOn" header="Date/Time" [sortable]="true" [editable]="false" [style]="{'width': '15%'}">
            <ng-template pTemplate="body" let-item="rowData">
                <div title="{{item.updatedOn | date:'dd/MM/yyyy HH:mm'}}">
                    {{ item.updatedOn | date:'dd/MM/yyyy HH:mm'}}
                </div>
            </ng-template>
        </p-column>
    </p-dataTable>

    --->

<div class="footerPanel ui-grid-row">
  <button
    type="button"
    pButton
    icon="fa ui-icon-trash"
    class="ui-button red-btn btn-to-right"
    label="Delete"
    (click)="deleteWeight()"
    [disabled]="!selectedWeight || !isPricingAdmin"
  ></button>
  <button
    type="button"
    pButton
    icon="fa ui-icon-add"
    (click)="addPostcodeWeight()"
    label="Add"
    class="btn-to-right"
    [disabled]="!isPricingAdmin"
  ></button>
</div>
<ng-template #loading>Loading...</ng-template>

<p-dialog
  header="Add Postcode Weight"
  [(visible)]="showAddPostcodeDlg"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div
    class="ui-grid-row ui-grid-responsive ui-fluid"
    style="margin-top: 10px; margin-bottom: 10px"
  >
    <div class="ui-grid-col-4">Postcode</div>
    <div class="ui-grid-col-8">
      <textarea
        [(ngModel)]="pItem.postcode"
        [style]="{ width: '100%' }"
        pInputTextarea
        [rows]="3"
      ></textarea>
    </div>
  </div>

  <div
    class="ui-grid-row ui-grid-responsive ui-fluid"
    style="margin-top: 10px; margin-bottom: 10px"
  >
    <div class="ui-grid-col-4">Customer Weighting</div>
    <div class="ui-grid-col-8">
      <!--<p-spinner [(ngModel)]="pItem.customerWeight" [min]="1" [max]="10" [step]="1"></p-spinner>-->
      <input pInputText [(ngModel)]="pItem.customerWeight" [minVal]="0" [maxVal]="10" />
    </div>
  </div>

  <div
    class="ui-grid-row ui-grid-responsive ui-fluid"
    style="margin-top: 10px; margin-bottom: 10px"
  >
    <div class="ui-grid-col-4">Supplier Weighting</div>
    <div class="ui-grid-col-8">
      <!--<p-spinner [(ngModel)]="pItem.supplierWeight" [min]="1" [max]="10" [step]="1"></p-spinner>-->
      <input pInputText [(ngModel)]="pItem.supplierWeight" [minVal]="0" [maxVal]="10" />
    </div>
  </div>

  <div
    class="ui-grid-row ui-grid-responsive ui-fluid"
    style="margin-top: 10px; margin-bottom: 10px"
  >
    <div class="ui-grid-col-4">Comments</div>
    <div class="ui-grid-col-8">
      <textarea
        [(ngModel)]="pItem.comments"
        [style]="{ width: '100%' }"
        pInputTextarea
        [rows]="3"
      ></textarea>
    </div>
  </div>

  <div class="ui-grid-row" style="margin-top: 20px">
    <button
      type="button"
      (click)="showAddPostcodeDlg = false"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      class="ui-button btn-to-right"
    ></button>

    <button
      type="button"
      (click)="savePostcodeWeight(pItem)"
      pButton
      label="Save"
      [disabled]="!(pItem.postcode && pItem.comments)"
      class="ui-button green-btn btn-to-right"
    ></button>
  </div>
</p-dialog>

<p-dialog
  header="Delete Postcode Weight"
  [(visible)]="showDeletePostcodeDlg"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <div
    class="ui-grid-row ui-grid-responsive ui-fluid"
    style="margin-top: 10px; margin-bottom: 10px"
  >
    <div class="ui-grid-col-12">Are you sure want to delete selected item?</div>
  </div>

  <div class="ui-grid-row" style="margin-top: 20px">
    <button
      type="button"
      (click)="showDeletePostcodeDlg = false"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      class="ui-button btn-to-right"
    ></button>

    <button
      type="button"
      (click)="deleteWeightConfirm(selectedWeight)"
      pButton
      label="Confirm"
      class="ui-button green-btn btn-to-right"
    ></button>
  </div>
</p-dialog>

<p-dialog
  header="Downloading Report"
  [responsive]="true"
  [closable]="true"
  [(visible)]="showProgressBar"
  [modal]="true"
  [style]="{ width: '300px' }"
>
  <p-progressBar mode="indeterminate"></p-progressBar>
</p-dialog>
